'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _required = require('../../lib/WithValidation/rules/required');

var _required2 = _interopRequireDefault(_required);

var _phone = require('../../lib/WithValidation/rules/phone');

var _phone2 = _interopRequireDefault(_phone);

var _blacklistedCharacters = require('../../lib/WithValidation/rules/blacklistedCharacters');

var _blacklistedCharacters2 = _interopRequireDefault(_blacklistedCharacters);

var _noSpecialCharacters = require('../../lib/WithValidation/rules/noSpecialCharacters');

var _noSpecialCharacters2 = _interopRequireDefault(_noSpecialCharacters);

var _stringWithoutNumbers = require('../../lib/WithValidation/rules/stringWithoutNumbers');

var _stringWithoutNumbers2 = _interopRequireDefault(_stringWithoutNumbers);

var _WithValidation = require('../../lib/WithValidation');

var _WithValidation2 = _interopRequireDefault(_WithValidation);

var _Input = require('../../components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Select = require('../../components/Select');

var _Select2 = _interopRequireDefault(_Select);

var _translate = require('../../lib/utils/translate');

var _translate2 = _interopRequireDefault(_translate);

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _countryEmojiFlags = require('../../misc/countryEmojiFlags');

var _countryEmojiFlags2 = _interopRequireDefault(_countryEmojiFlags);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var genders = [{
  label: function label(intl) {
    return (0, _translate2.default)({
      id: 'noun.male',
      defaultMessage: 'Male'
    }, intl);
  },
  value: 'Male'
}, {
  label: function label(intl) {
    return (0, _translate2.default)({
      id: 'noun.female',
      defaultMessage: 'Female'
    }, intl);
  },
  value: 'Female'
}, {
  label: function label(intl) {
    return (0, _translate2.default)({
      id: 'noun.other',
      defaultMessage: 'Other'
    }, intl);
  },
  value: 'Other'
}];

var AccountDetail = function AccountDetail(_ref) {
  var data = _ref.data,
      intl = _ref.intl,
      errors = _ref.errors,
      onSubmit = _ref.onSubmit,
      jurisdiction = _ref.jurisdiction,
      countries = _ref.countries,
      isLoading = _ref.isLoading,
      isComplete = _ref.isComplete,
      showCallingCode = _ref.showCallingCode;

  return _react2.default.createElement(
    'form',
    { className: 'form', onSubmit: onSubmit },
    _react2.default.createElement(
      'div',
      { className: 'layout-item' },
      _react2.default.createElement(_Input2.default, {
        disabled: true,
        className: 'layout-item-6',
        value: data.FirstName,
        label: (0, _translate2.default)({
          id: 'title.first_name',
          defaultMessage: 'First name'
        }, intl),
        name: 'FirstName',
        status: errors.FirstName && 'failure' || 'idle',
        statusText: errors.FirstName && (0, _translate2.default)({ id: errors.FirstName }, intl)
      }),
      _react2.default.createElement(_Input2.default, {
        disabled: true,
        className: 'layout-item-6',
        value: data.LastName,
        label: (0, _translate2.default)({
          id: 'title.last_name',
          defaultMessage: 'Last name'
        }, intl),
        name: 'LastName',
        status: errors.LastName && 'failure' || 'idle',
        statusText: errors.LastName && (0, _translate2.default)({ id: errors.LastName }, intl)
      })
    ),
    _react2.default.createElement(_Input2.default, {
      label: (0, _translate2.default)({
        id: 'title.address',
        defaultMessage: 'Address'
      }, intl),
      name: 'Address1',
      value: data.Address1,
      status: errors.Address1 && 'failure' || 'idle',
      statusText: errors.Address1 && (0, _translate2.default)({ id: 'errors.Address1' }, intl),
      autoComplete: 'off'
    }),
    _react2.default.createElement(
      'div',
      { className: 'layout-item' },
      _react2.default.createElement(_Input2.default, {
        className: 'layout-item-6',
        value: data.Zip,
        label: (0, _translate2.default)({ id: 'title.zip', defaultMessage: 'Zip' }, intl),
        name: 'Zip',
        status: errors.Zip && 'failure' || 'idle',
        statusText: errors.Zip && (0, _translate2.default)({ id: errors.Zip }, intl),
        autoComplete: 'off'
      }),
      _react2.default.createElement(_Input2.default, {
        className: 'layout-item-6',
        value: data.City,
        label: (0, _translate2.default)({
          id: 'title.city',
          defaultMessage: 'City'
        }, intl),
        name: 'City',
        status: errors.City && 'failure' || 'idle',
        statusText: errors.City && (0, _translate2.default)({ id: errors.City }, intl),
        autoComplete: 'off'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'layout-item' },
      _react2.default.createElement(
        _Select2.default,
        {
          disabled: isComplete,
          className: 'layout-item-6',
          value: data.Country,
          label: (0, _translate2.default)({
            id: 'title.country',
            defaultMessage: 'Country'
          }, intl),
          name: 'Country',
          icon: _react2.default.createElement(_Icon2.default, { icon: 'flag' }) },
        countries.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        }).map(function (c) {
          return _react2.default.createElement(
            _Select2.default.Option,
            { key: c.value, value: c.value },
            c.label
          );
        })
      ),
      _react2.default.createElement(_Input2.default, {
        disabled: true,
        className: 'layout-item-6',
        value: intl.formatDate(new Date(data.BirthDate)),
        label: (0, _translate2.default)({
          id: 'title.user_birthday',
          defaultMessage: 'Birthday'
        }, intl),
        name: 'BirthDate'
      })
    ),
    _react2.default.createElement(_Input2.default, {
      value: data.MobilePhoneNumber,
      type: 'tel',
      label: (0, _translate2.default)({
        id: 'title.mobile_number',
        defaultMessage: 'Mobile number'
      }, intl),
      callingCodes: showCallingCode && countries ? countries.sort(function (a, b) {
        return Number(a.callingCode) - Number(b.callingCode);
      }).map(function (i) {
        return {
          value: '00' + i.callingCode,
          label: '+' + i.callingCode + ' ' + (_countryEmojiFlags2.default[i.value] || '')
        };
      }) : [],
      name: 'MobilePhoneNumber',
      autoComplete: 'off',
      status: errors.MobilePhoneNumber && 'failure' || 'idle',
      statusText: errors.MobilePhoneNumber && (0, _translate2.default)({ id: errors.MobilePhoneNumber }, intl)
    }),
    _react2.default.createElement(
      'div',
      { className: 'layout-item' },
      _react2.default.createElement(_Input2.default, {
        className: 'layout-item-6',
        disabled: true,
        value: data.Email,
        label: (0, _translate2.default)({
          id: 'title.email',
          defaultMessage: 'Email'
        }, intl),
        name: 'Email'
      }),
      _react2.default.createElement(
        _Select2.default,
        {
          className: 'layout-item-6',
          value: data.Gender,
          label: (0, _translate2.default)({
            id: 'title.gender',
            defaultMessage: 'Gender'
          }, intl),
          name: 'Gender',
          status: errors.Gender && 'failure' || 'idle',
          statusText: errors.Gender && (0, _translate2.default)({ id: errors.Gender }, intl) },
        _react2.default.createElement(
          _Select2.default.Option,
          { value: '', disabled: true },
          (0, _translate2.default)({
            id: 'label.select-gender',
            defaultMessage: 'Select gender'
          }, intl)
        ),
        genders.map(function (gender) {
          return _react2.default.createElement(
            _Select2.default.Option,
            { value: gender.value },
            gender.label(intl)
          );
        })
      )
    ),
    !['sga', 'dga'].includes(jurisdiction) && _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_Input2.default, { type: 'hidden', name: 'trap_username' }),
      _react2.default.createElement(_Input2.default, {
        value: '',
        type: 'password',
        label: (0, _translate2.default)({
          id: 'title.password',
          defaultMessage: 'Password'
        }, intl),
        name: 'Password',
        status: errors.Password && 'failure' || 'idle',
        statusText: errors.Password && (0, _translate2.default)({ id: errors.Password }, intl),
        autocomplete: 'new-password'
      })
    ),
    _react2.default.createElement(
      _Button2.default,
      {
        className: 'button primary wide',
        type: 'submit',
        isLoading: isLoading },
      (0, _translate2.default)({
        id: 'action.button.save_changes',
        defaultMessage: 'Save'
      }, intl)
    )
  );
};

AccountDetail.propTypes = {
  /** Disables field */
  disabled: _propTypes2.default.func,
  /** The form input fields and content */
  children: _propTypes2.default.any,
  /** The above title for each field */
  label: _propTypes2.default.string,
  /** The value inside each field */
  value: _propTypes2.default.any,
  /** The name of each field */
  name: _propTypes2.default.string,
  /** Array of validation errors where the error display depends on which invalid rule it breaks */
  error: _propTypes2.default.array,
  /** The submission function firing when submitting the form */
  onSubmit: _propTypes2.default.func,
  /** If the user profile is complete or not */
  isComplete: _propTypes2.default.bool
};

AccountDetail.defaultProps = {
  disabled: Function,
  children: '',
  label: '',
  value: '',
  name: '',
  error: [],
  onSubmit: Function,
  isComplete: false
};

var rules = {
  MobilePhoneNumber: [[_required2.default, 'error.empty.mobilePhoneNumber'], [_phone2.default, 'error.condition.phone']],
  Address1: [[_required2.default, 'error.empty.address'], [_blacklistedCharacters2.default, 'error.format.address']],
  Zip: [[_required2.default, 'error.empty.zip_code'], [_noSpecialCharacters2.default, 'error.format.zip']],
  City: [[_required2.default, 'error.empty.city'], [_stringWithoutNumbers2.default, 'error.invalid.city'], [_blacklistedCharacters2.default, 'error.invalid.city']],
  Password: [[_required2.default, 'error.empty.password']],
  Country: [[_required2.default, 'error.empty.country']],
  Gender: [[_required2.default, 'error.empty.gender']]
};

exports.default = (0, _compose2.default)((0, _WithValidation2.default)(rules), _reactIntl.injectIntl)(AccountDetail);